<template>
    <div>
       <!--  <button v-if="!display" type="button" class="btn btn-theme float-end" @click="display = true">View Google Map</button> -->
        <div v-show="display" class="hm-google-map" :id="$props.mapId" :style="{height: $props.height, width: $props.width}"></div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    props: {
        mapId: {
            type: String,
            default: 'hm-google-map'
        },
        height: {
            default: '200px'
        },
        width: {
            default: '100%'
        },
        zoom: {
            type: Number,
            default: 9
        },
        orders: {
            type: Array,
            required: true,
            default: []
        },
        markers: {
            type: Array,
            //required: true,
            default: []
        },
        display: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            center:{},
            currentInfoWindow: null,
        }
    },
    created() {

    },
    mounted() {
        this.initMap();
    },
    computed: {
        displayMap() {
            return this.display;
        }
    },
    methods: {
        formatDate(date, format) {
            return moment(date).format(format);
        },
        initMap() {
            document.getElementById(this.$props.mapId).innerHTML = '';
            if (!this.$el) {
                console.error('Element not found');
                return;
            }
            if (this.$props.orders.length == 0) {
                document.getElementById(this.$props.mapId).innerHTML = '<div class="text-center p-4">There no orders available.</div>';
                return;
            }

            // Check center is empty then set center
            if (this.$props.orders.length > 0) {
                // Iterate the markers and convert the position lat lng to number and set center
                //this.$props.markers.forEach(marker => {
                //    marker.position.lat = parseFloat(marker.position.lat);
                //    marker.position.lng = parseFloat(marker.position.lng);
                //})
                this.center = {
                    lat: Number(this.$props.orders[0].latitude),
                    lng: Number(this.$props.orders[0].longitude)
                }
            }
            this.center = {
                lat: Number(this.$props.orders[0].latitude),
                lng: Number(this.$props.orders[0].longitude)
            }

            const map = new google.maps.Map(document.getElementById(this.$props.mapId), {
                zoom: this.$props.zoom,
                center: this.center
            });

            this.$props.orders.forEach(order => {
                const marker = new google.maps.Marker({
                    position: {lat: Number(order.latitude), lng: Number(order.longitude)},
                    map: map,
                    title: order.full_address,
                });

                // Prepare infoWindow data

                let infoWindowContent = '';
                if (typeof order.name !== 'undefined') {
                    infoWindowContent += `<h6>${order.name}</h6>`;
                }

                // Check for due date service name
                if (typeof order.service_name !== 'undefined') {
                    infoWindowContent += `<h6>${order.service_name}</h6>`;
                }

                // Check if address is not undefined then add it
                if (typeof order.full_address !== 'undefined') {
                    infoWindowContent += `<p class="mb-2"><b>Address</b>: ${order.full_address}</p>`;
                }

                // Check if postcode is not undefined then add it
                if (typeof order.postal_code !== 'undefined') {
                    infoWindowContent += `<p class="mb-2"><b>Postcode</b>: ${order.postal_code}</p>`;
                }

                // Check if booking date is not undefined then add it
                if (typeof order.booking_date !== 'undefined') {
                    let bookingDate = this.formatDate(order.booking_date, 'DD MMM YYYY');
                    infoWindowContent += `<p class="mb-2"><b>Date</b>: ${bookingDate}</p>`;
                }

                // Check for due date service
                if (typeof order.due_date !== 'undefined') {
                    let dueDate = this.formatDate(order.due_date, 'DD MMM YYYY');
                    infoWindowContent += `<p class="mb-2"><b>Due Date</b>: ${dueDate}</p>`;
                }

                // due date service customer name
                if (typeof order.customer_full_name !== 'undefined') {
                    infoWindowContent += `<p class="mb-2"><b>Customer</b>: ${order.customer_full_name}</p>`;
                }

                // Due date customer email
                if (typeof order.customer_email !== 'undefined') {
                    infoWindowContent += `<p class="mb-2"><b>Email</b>: ${order.customer_email}</p>`;
                }

                // Due date customer phone
                if (typeof order.customer_phone_number !== 'undefined') {
                    infoWindowContent += `<p class="mb-2"><b>Phone</b>: ${order.customer_phone_number}</p>`;
                }

                // Check if total amount is not undefined then add it
                if (typeof order.total_amount !== 'undefined') {
                    infoWindowContent += `<p class="mb-2"><b>Amount</b>: £${order.total_amount}</p>`;
                }

                // Check if handymans is not empty then add it
                if (typeof order.handymans !== 'undefined' && order.handymans.length > 0) {
                    infoWindowContent += `<p class="mb-2"><b>Handyman</b>: `;
                    order.handymans.forEach( handyman => {
                        infoWindowContent += `${handyman.name},`
                    });

                    // Remove last comma
                    infoWindowContent = infoWindowContent.slice(0, -1);
                    infoWindowContent += `</p>`;
                }

                const infoWindow = new google.maps.InfoWindow({
                    content: infoWindowContent
                });

                marker.addListener('click', () => {
                    if (this.currentInfoWindow) {
                        this.currentInfoWindow.close();
                    }
                    infoWindow.open(map, marker);
                    this.currentInfoWindow = infoWindow;
                });
            });
        }
    },
    updated() {
        this.initMap();
    }
}
</script>
<style scoped>

</style>
